import React from "react"
import { ITextProps } from "../../types/textTypes"
import mapStylesFromProps from "../../utils/mapStylesFromProps"

interface Props extends ITextProps {
  to: string
}

const RefLink = (props: Props) => {
  const className = `font-raleway-light text-[6px] underline ${mapStylesFromProps(
    props
  )}`
  return (
    <a
      href={props.to}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      {props.children}
    </a>
  )
}

export default RefLink
